import { QueryClient, type QueryKey } from '@tanstack/react-query';
import { ApiError } from './errors';

/** One place for cache policy: pages get consistent behavior for free. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // A 4xx is deterministic (bad input, no permission, gone): retrying
        // only delays the message. Everything else gets the default 3 tries.
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return failureCount < 3;
        },
      },
    },
  });
}

/**
 * Marks every query under each key root stale (active ones refetch now,
 * inactive ones on their next mount). A write lists every root whose server
 * data it changes; docs/query-invalidation.md is the audit of those lists.
 */
export function invalidateRoots(client: QueryClient, roots: readonly QueryKey[]): void {
  for (const queryKey of roots) void client.invalidateQueries({ queryKey });
}
